// extracted by mini-css-extract-plugin
module.exports = {"mediaPlayer":"media-player_mediaPlayer__xDycg"};